import SelectableGridController from "../../selectable_grid/selectable_grid";

export default class extends SelectableGridController {
  static values = { themes: Object, selected: String };
  static targets = ["themeName"];

  handleRadioClick(event) {
    const radio = event.target;
    const selectedThemeId = String(radio.value).trim();

    if (!selectedThemeId || !this.hasThemesValue) {
      return;
    }

    const themeData = this.themesValue[selectedThemeId];

    if (!themeData) {
      console.warn("Theme data not found for ID:", selectedThemeId);
      return;
    }

    this.selectedValue = selectedThemeId;
    this.updateMobileItems(radio);
    this.updateGalleryCarousel(themeData.page_images || [], themeData.name);
  }

  updateGalleryCarousel(pageImages, themeName) {
    const galleryElement = this.element.querySelector('[data-controller="gallery-carousel"]');
    if (!galleryElement) return;

    const galleryController = this.application.getControllerForElementAndIdentifier(
      galleryElement,
      "gallery-carousel"
    );

    if (galleryController) {
      const imageUrls = pageImages.map((img) => img.path);
      const labels = pageImages.map((img) => img.description ? `${themeName} - Page ${img.description}` : null);
      galleryController.setImages(imageUrls, labels);
    }

    if (this.hasThemeNameTarget) {
      this.themeNameTarget.textContent = themeName;
    }
  }
}
